import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { EndPoints } from 'src/@shared/shared/enum';

@Injectable({
  providedIn: 'root',
})
export class PaymentsApiClient {
  constructor(private commonService: CommonService) {}

  updatePayment(payload: unknown): Observable<unknown> {
    return this.commonService.API_POST(EndPoints.UpdatePayment, payload, false);
  }

  cancelPayment(payload: unknown): Observable<unknown> {
    return this.commonService.API_POST(EndPoints.CancelPayment, payload, false);
  }

  previewQboAttachment(qboAttachmentId: string | number): Observable<unknown> {
    return this.commonService.API_GET(
      `${EndPoints.PreviewQBOAttachment}?QBOAttachmentId=${qboAttachmentId}`,
      false
    );
  }
}
